import { PayrollCountryType } from '@nxsys/types/models/Common';

/**
 * Which payroll country a freshly installed session means (NX-5833).
 *
 * Pulled out of `appSlice` so it can be tested: the slice reaches
 * `import.meta.env` through the axios config, which the jest setup here cannot
 * load. Keeping the rule in one named place also stops the next session factory
 * from inventing its own version of it.
 *
 * The backend states the country on every session it mints. `held` covers the
 * sessions that do not: an older backend, or any future response that forgets.
 * Without it the country went to `''`, and an empty country is read as the
 * United Kingdom by the switcher and the menu filter — which silently moved an
 * Ireland bureau user's whole app.
 */
export interface SessionCountrySource {
  id?: string;
  payrollCountry?: PayrollCountryType | null;
  companyParent?: { payrollCountry?: PayrollCountryType | null } | null;
}

export interface HeldCountry {
  /** The user the current store state belongs to. */
  userId?: string;
  payrollCountry?: PayrollCountryType | null;
}

export const resolvePayrollCountry = (
  session: SessionCountrySource | null | undefined,
  held?: HeldCountry,
): PayrollCountryType => {
  // Scoped to the same user on purpose: signing in as somebody else must still
  // be able to change the country, including to nothing.
  const isSameUser =
    !!held?.userId && !!session?.id && held.userId === session.id;

  return (
    session?.payrollCountry ||
    session?.companyParent?.payrollCountry ||
    (isSameUser ? held?.payrollCountry : '') ||
    ''
  );
};
